import type { DeepPartial } from '@luna/utils-ts';

import type { RegularOrders } from '../../types/RegularOrders';

export const regularOrdersCZFeatureConfig: DeepPartial<RegularOrders> = {
    note: true,
    validFrom: true,
    validUntil: true,
};
